/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminContractItemDto } from './AdminContractItemDto';
import {
    AdminContractItemDtoFromJSON,
    AdminContractItemDtoFromJSONTyped,
    AdminContractItemDtoToJSON,
    AdminContractItemDtoToJSONTyped,
} from './AdminContractItemDto';

/**
 * 
 * @export
 * @interface GetAdminContractListResponse
 */
export interface GetAdminContractListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetAdminContractListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<AdminContractItemDto>}
     * @memberof GetAdminContractListResponse
     */
    items: Array<AdminContractItemDto>;
}

/**
 * Check if a given object implements the GetAdminContractListResponse interface.
 */
export function instanceOfGetAdminContractListResponse(value: object): value is GetAdminContractListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetAdminContractListResponseFromJSON(json: any): GetAdminContractListResponse {
    return GetAdminContractListResponseFromJSONTyped(json, false);
}

export function GetAdminContractListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminContractListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(AdminContractItemDtoFromJSON)),
    };
}

export function GetAdminContractListResponseToJSON(json: any): GetAdminContractListResponse {
    return GetAdminContractListResponseToJSONTyped(json, false);
}

export function GetAdminContractListResponseToJSONTyped(value?: GetAdminContractListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(AdminContractItemDtoToJSON)),
    };
}

